module.exports = __webpack_public_path__ + "static/media/no-direct-reportees.7c0fedd2.svg";